'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "InlineStack": "Polaris-InlineStack"
};

exports.default = styles;
